<template>
  <v-abstract-menu-option :dialog-width="290" :showing-dialog.sync="showingDialog">
    <template #info>Fecha mínima LastPriceUpdate: {{ appSettings.minLastPriceUpdate || 'Ninguna' }}</template>
    <template #input>
      <v-date-picker v-model="date">
        <v-spacer />
        <v-btn flat color="grey" @click="setDateAndCloseDialog(null)">NINGUNA</v-btn>
        <v-btn flat color="blue" @click="setDateAndCloseDialog(date)">OK</v-btn>
      </v-date-picker>
    </template>
  </v-abstract-menu-option>
</template>

<script>
import VAbstractMenuOption from "./AbstractMenuOption";

/**
 * An option for the menu to set the minimum last price update to
 * load items above this date only.
 *
 * This option assumes that you have an `appSettings` object with the
 * `minLastPriceUpdate` attribute in the store with the given `namespace`
 * and an action with name `setAppSettingsMinLastPriceUpdate` to change
 * the value.
 *
 * With this component is a file with a base butation if you want to use it
 * in your store.
 */
export default {
  components: {
    VAbstractMenuOption
  },
  props: {
    /**
     * The namespace of the module in the vuex store.
     */
    namespace: {
      type: String,
      required: true
    }
  },
  computed: {
    appSettings() {
      return this.$store.state[this.namespace].appSettings;
    }
  },
  data: () => ({
    date: null,
    showingDialog: false
  }),
  methods: {
    async setDateAndCloseDialog(value) {
      this.$store.dispatch(
        `${this.namespace}/setAppSettingsMinLastPriceUpdate`,
        value
      );
      this.showingDialog = false;
    }
  }
};
</script>
